// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ng-select .ng-select-container\r\n{\r\n    border: 0px;    \r\n}", "",{"version":3,"sources":["webpack://./src/app/connection/connection.component.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf","sourcesContent":[".ng-select .ng-select-container\r\n{\r\n    border: 0px;    \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
